module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0001_mrWedensday.72b8de2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0001_mrWedensday.jpg
// module id = usUH
// module chunks = 1